import React from 'react';

const CalculateButton = () => {
  return (
    <button className="ui purple circular button" label="Calculate" type="submit">
      Calculate
    </button>
  );
};

export default CalculateButton;
